import { HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, throwError } from 'rxjs';

import { PageForbiddenService, isPageForbiddenBody } from '@core/services/page-forbidden.service';

import { environment } from '@environments/environment';

/**
 * Shows the notice "Keine Berechtigung" when the API answers `403 { error: 'page_forbidden' }`. The error is still
 * re-thrown so the failing caller stops normally and keeps whatever it showed before.
 */
export const pageForbiddenInterceptor: HttpInterceptorFn = (req, next) => {
  const notice = inject(PageForbiddenService);
  if (!req.url.startsWith(environment.apiBaseUrl)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 403 && isPageForbiddenBody(err.error)) {
        notice.show();
      }
      return throwError(() => err);
    }),
  );
};
